import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { resetCheckout } from '../../containers/Checkout/checkoutSlice';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const CheckoutFailure = (props) => {
	const { error, resetCheckout } = props;

	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate('/');
		resetCheckout();
	};

	return (
		<Box sx={{ px: { xs: 3, sm: 10, xl: 50 } }}>
			<Stack spacing={4} sx={{ mt: { xs: 1, md: 4 }, py: { xs: 1, md: 2 } }}>
				<Typography
					variant='h1'
					sx={{ fontSize: { xs: '2rem', sm: '2.7rem', md: '3.2rem' }, fontWeight: '500' }}
				>
					Checkout
				</Typography>
				<Typography
					variant='h5'
					sx={{
						fontSize: { xs: '0.9rem', lg: '1.35rem' }
					}}
				>
					Uh oh! Something went wrong when trying to process your order. Please try again.
				</Typography>
				<Button onClick={handleGoBack} sx={{ width: '15%' }}>
					Back To Home
				</Button>
			</Stack>
			<Stack direction='row' divider={<Divider orientation='vertical' flexItem />} spacing={5}>
				<Stack>
					<Typography fontWeight={700} variant='h6'>
						Error Code
					</Typography>
					<Typography variant='h6'>{error?.errorCode}</Typography>
				</Stack>
				<Stack>
					<Typography fontWeight={700} variant='h6'>
						Message
					</Typography>
					<Typography variant='h6'>{error?.errorText}</Typography>
				</Stack>
			</Stack>
		</Box>
	);
};

CheckoutFailure.propTypes = {
	error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	resetCheckout: PropTypes.func
};

const mapStateToProps = (state) => {
	return {
		error: state.checkoutSlice.error
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		resetCheckout: () => {
			dispatch(resetCheckout());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutFailure);
